import $ from "utils/net";
import { ManualPaymentMethod, ManualDepositFormData } from "./types";

interface ApiResponse<T> {
    status: string;
    errors?: string[];
    data?: T;
}

interface MethodsResponse extends ApiResponse<{ id: string }> {
    methods?: ManualPaymentMethod[];
}

export class ManualDepositService {
    constructor(private readonly endpoint: string) {}

    async getMethods(): Promise<ManualPaymentMethod[]> {
        const res = await new Promise<MethodsResponse>((res, rej) =>
            $.getJSON(this.endpoint + '/manual_deposit/getMethods', (err, data) =>
                err ? rej(err) : res(data)
            )
        );
        if (res.status !== 'ok' || !res.methods) throw new Error('Failed to load methods');
        return res.methods;
    }

    async submitDeposit(data: ManualDepositFormData): Promise<string> {
        const body: Record<string, string> = { method_id: data.methodId, amount: data.amount, note: data.note };

        const res = await new Promise<ApiResponse<{ id: string }>>((res, rej) =>
            $.post(this.endpoint + '/manual_deposit/requestDeposit', {
                body,
                json: true,
            }, (err, data) =>
                err ? rej(err) : res(data)
            )
        );
        if (res.status !== 'ok') {
            throw new Error(res.errors?.[0] || 'Deposit request failed');
        }
        return res.data!.id;
    }

    async uploadScreenshot(depositId: string, file: File): Promise<void> {
        const authToken = window.safeSessionStorage.getItem('SF-Auth-Token');
        const headers: Record<string, string> = {};
        if (authToken) headers['X-Auth-Token'] = authToken;

        const fd = new FormData();
        fd.append('file', file);

        const res = await fetch(this.endpoint + '/manual_deposit/uploadScreenshot/' + depositId, {
            method: 'POST',
            credentials: 'include',
            headers,
            body: fd,
        });
        const json = await res.json();
        if (json.status !== 'ok') {
            throw new Error(json.errors?.[0] || 'Screenshot upload failed');
        }
    }
}
